<template>

  <data-form
    :entity="mappedInput"
    :fields="fields"
    model="inputs"
    :cancel="false"
  /> 

</template>

<script>
import findAll from 'service/findAll'
import inputTypes from '../controller/inputTypes'

export default {
  name: 'input-form',
  props: {
    input: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields () {
      return {
        'hardverId': {
          disabled: true
        },
        'name': {
        },
        'type': {
          type: 'select',
          options: inputTypes
        },
        'event_switch_id': {
          type: 'select',
          options: this.switchOptions
        },
        'event_timeout': {
          type: 'number'
        },
        'alarm_switch_id': {
          type: 'select',
          options: this.switchOptions
        }
      }
    },
    mappedInput () {
      return {
        ...this.input,
        hardverId: this.input.index === 1 ? this.$t('controller') : this.$t('wiegand')
      }
    }
  },
  mixins: [
    findAll('switches', 'switchOptions', {
      filter ({ controller_id }) { return controller_id === this.input.controller_id },
      map ({ id, name }) { return { value: id, label: name } }
    })
  ]
}
</script>



// WEBPACK FOOTER //
// InputForm.vue?3a6d19a6